import Badge from '@components/Badge';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { PrepaidCardGiftBoxRow } from '@models/prepaidCard';
import { ReceivedPrepaidCardBadgeColor } from '@models/prepaidCard/receivedPrepaidCard';
import { useFlow } from '@stackflow/react';
import { pressActionEffect } from '@styles/mixin';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

interface Props {
    gift: PrepaidCardGiftBoxRow;
}

function GiftBoxItem({ gift }: Props) {
    const { t } = useTranslation('prepaidCard');
    const { push } = useFlow();

    const handleClick = () => {
        push('PrepaidCardGiftDetailActivity', { giftBoxId: gift.id });
    };

    return (
        <Container type='button' onClick={handleClick} css={pressActionEffect}>
            <Image src={gift.imageUrl}
                width={100}
                height={67}
                alt={gift.giftItemName ?? ''}
                style={{ borderRadius: 8, objectFit: 'cover', flexShrink: 0 }} />
            <Info>
                <Text size='body-short' color={colors.textThird}>
                    {t('giftBox.from', {
                        name: gift.senderName === 'SELF' ? t('giftBox.me') : gift.senderName,
                    })}
                </Text>
                <Text size='body-short' fontWeight='medium'>
                    {gift.giftItemName}
                </Text>
                <Meta>
                    <Text size='body-long' color={colors.textSecondary}>
                        {t('giftBox.sentAt', { date: dayjs(gift.sentAt).format('YYYY.MM.DD') })}
                    </Text>
                    <Badge color={ReceivedPrepaidCardBadgeColor[gift.status]}>
                        {t(`giftBox.status.${gift.status}`)}
                    </Badge>
                </Meta>
            </Info>
        </Container>
    );
}

const Container = styled.button`
    align-items: center;
    background: transparent;
    border: none;
    display: flex;
    gap: 16px;
    padding: 16px 0;
    text-align: left;
    width: 100%;
`;

const Info = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`;

const Meta = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

export default GiftBoxItem;
